var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }),attrs:{"id":"root"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.show)?_c('router-view'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }